// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 225) return "static/chunks/225-57671f315ae3f6d7.js";
	if (chunkId === 394) return "static/chunks/394-ffe1c72ee73d9ab2.js";
	if (chunkId === 484) return "static/chunks/484-26ab3b93c2bfa1d9.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 496 ? "graphql-print" : chunkId) + "." + {"384":"29dd9ecb97530e01","496":"83edc8afc0370428","788":"b99d7b03b7061fbe"}[chunkId] + ".js";
};